import { render, staticRenderFns } from "./DeviceStatusNotification.vue?vue&type=template&id=2254e886&scoped=true"
import script from "./DeviceStatusNotification.vue?vue&type=script&lang=ts"
export * from "./DeviceStatusNotification.vue?vue&type=script&lang=ts"
import style0 from "./DeviceStatusNotification.vue?vue&type=style&index=0&id=2254e886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2254e886",
  null
  
)

export default component.exports